export class AppError extends Error {
    public name = 'AppError';
}
